<template>
  <div>
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1>Paramètres - Page d'accueil</h1>
    </div>

  <b-col><!-- General settings -->

    <b-row class="mt-3 pt-3">

      <b-col md="2">
        <label for="setting_main_logo">Image de landing page</label>
      </b-col>
      <b-col md="6" class="pull-right">
        <b-button @click="open_uploadcare('landing_image')"  class="pull-left">Sélectionner une image</b-button>
        <p class="text-info pt-2 small pull-right">Taille suggérée : 700 x 400px</p>
      </b-col>
      <b-col md="4" class="pull-right mb-4">
        <img :src="settings.logos.landing_image" class="img-fluid demo-img" />
      </b-col>

      <b-col md="2">
        <label>Titre section #1</label>
      </b-col>
      <b-col md="10">
        <b-form-input
          :value="settings.copy.home_section_1_title | translategrader(lang)"
          placeholder="Pour quoi faire ?"
          @input="updateSettingsCopy($event, 'home_section_1_title')">
        </b-form-input>
        <p class="text-info small mt-1">Titre de la première section</p>
      </b-col>

      <b-col md="2">
        <label>Texte section #1</label>
      </b-col>
      <b-col md="10">
        <b-form-textarea
          :value="settings.copy.home_section_1_text | translategrader(lang)"
          placeholder="Évaluez la performance de votre inbound marketing"
          @input="updateSettingsCopy($event, 'home_section_1_text')"
          rows="3"
          max-rows="6">
        </b-form-textarea>
        <p class="text-info small mt-1">Paragraphe de la première section. HTML possible</p>
      </b-col>

      <b-col md="2">
        <label>Titre section #2</label>
      </b-col>
      <b-col md="10">
        <b-form-input
          :value="settings.copy.home_section_2_title | translategrader(lang)"
          placeholder="Pour quoi faire ?"
          @input="updateSettingsCopy($event, 'home_section_2_title')">
        </b-form-input>
        <p class="text-info small mt-1">Titre de la seconde section</p>
      </b-col>

      <b-col md="2">
        <label>Texte section #2</label>
      </b-col>
      <b-col md="10">
        <b-form-textarea
          :value="settings.copy.home_section_2_text | translategrader(lang)"
          placeholder="Évaluez la performance de votre inbound marketing"
          @input="updateSettingsCopy($event, 'home_section_2_text')"
          rows="3"
          max-rows="6">
        </b-form-textarea>
        <p class="text-info small mt-1">Paragraphe de la seconde section. HTML possible</p>
      </b-col>

      <b-col md="2">
        <label>Titre section #3</label>
      </b-col>
      <b-col md="10">
        <b-form-input
          :value="settings.copy.home_section_3_title | translategrader(lang)"
          placeholder="On y va ?"
          @input="updateSettingsCopy($event, 'home_section_3_title')">
        </b-form-input>
        <p class="text-info small mt-1">Titre de la troisième section</p>
      </b-col>
    </b-row>
  </b-col>


  </div>

</template>

<script>

  import { mapGetters, mapActions } from 'vuex';
  import { Photoshop } from 'vue-color'

  export default {

    name: 'admin_settings',

    data() {
      return {
        selectedLang: [], // Must be an array reference!
        optionsLang: [
          { text: 'Français', value: 'fr' },
          { text: 'English', value: 'en' },
          { text: 'Italiano', value: 'it' },
          { text: 'Deutsch', value: 'de' }
        ],
        checked: false,
        showingColorPicker: {'primary': false, 'secondary': false},
        tempColor: "#fff",
      }
    },

    components: {
      'photoshop-picker': Photoshop,
    },

    computed: {
      ...mapGetters('settings', {
        settings: 'settings',
        isSaving: 'isSaving'
      }),

      bgc_primary : function() {
        return {backgroundColor: this.settings.colors.primary};
      },

      bgc_secondary : function() {
        return {backgroundColor: this.settings.colors.secondary};
      },

      lang : function() {
        return this.$i18n.locale;
      },
    },

    async created() {
      await this.getOrCreateSetting();
      if (Array.isArray(this.settings.available_lang)) {
        this.selectedLang = this.settings.available_lang;
      }
    },

    methods: {
      ...mapActions({
        getOrCreateSetting: 'settings/getOrCreateSetting',
        saveSettings: 'settings/saveSettings'
      }),

      open_uploadcare (image_name) {
        // var dialog = uploadcare.openDialog(this.quiz.background_image);
        var currentComponent = this;
        var fileInput = document.createElement('input');
        var widget = uploadcare.Widget(fileInput);
        widget.onUploadComplete(function(info) {
          console.log("File info!", info.cdnUrl);
          currentComponent.updateLogo(image_name, info.cdnUrl)
        });
        widget.openDialog();
      },

      updateLogo(image_name, url) {
        var tmpSettings = this.settings;
        tmpSettings["logos"][image_name] = url;
        this.saveSettings(tmpSettings);
      },

      updateSettingsCopy(value, targetKey) {
        // Saving title in current language
        var tmpSettings = this.settings;
        if (typeof this.$i18n.locale === "undefined") {
          tmpSettings.copy[targetKey] = value;
          // we might need to cover multi-> single languages at some point
          // (or just fallback "en" or "fr" by default)
        }
        else {
          if (typeof tmpSettings.copy[targetKey] !== 'undefined' && tmpSettings.copy[targetKey].constructor == Object) {
            // If we already have a lang dict
            tmpSettings.copy[targetKey][this.$i18n.locale] = value;
          } else {
            // else we have a non-multiligual string. We need to erase it first
            var newSettings = tmpSettings.copy;
            delete newSettings[targetKey];
            newSettings[targetKey] = {};
            newSettings[targetKey][this.$i18n.locale] = value;
          }
        }
        this.saveSettings(tmpSettings);
      },
    },

  }
</script>



<style scoped>
h2 {
  color: #005E88;
}

.colorDemo {
  float: right;
  width: 15px;
  height: 15px;
  border: 1px solid #DDD;
  background-color: #0000F2;
}

.demo-img {
  background: #eee;
  padding: 20px;
}

.spinnerSave {
  position: fixed;
  bottom: 20px;
  right: 20px;
}

.vc-photoshop {
  position: absolute;
  right: 0px;
  top: 50px;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/settings/AdminSettingsHomePage.vue